
const Comment = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="#437EF7"
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
  >
    <path
      fillRule="evenodd"
      d="m1.317 12.567 2.317-2.317h7.241c1.036 0 1.875-.84 1.875-1.875v-6.25c0-1.036-.84-1.875-1.875-1.875h-8.75C1.089.25.25 1.09.25 2.125v10c0 .557.673.836 1.067.442ZM3.375 9a.625.625 0 0 0-.442.183L1.5 10.616V2.125c0-.345.28-.625.625-.625h8.75c.345 0 .625.28.625.625v6.25c0 .345-.28.625-.625.625h-7.5Z"
      clipRule="evenodd"
    />
  </svg>
)
export default Comment
